import React from 'react';
import _head from 'lodash/head';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import { Box, Stack } from '@lyearn/ui';
import { Image } from '@/components/Image';
import RichTextViewer from '@/components/RichTextViewer';
import { renderAttachments } from '@/modules/corporate/modules/questions/fields/components/Player/OptionsListItem/renderers';

import { questionCodeStyles } from './styles';
import { QuestionTextProps } from './types';

// Fixed per breakpoint, independent of question length, so font size stays
// consistent across every question in a quiz instead of jumping around.
function getVariant({ isMobile }: { isMobile: boolean }) {
  return isMobile ? 'heading-xs' : 'heading-s';
}

function QuestionText(props: QuestionTextProps) {
  const { classes, question, ...rest } = props;
  const { isMobile } = useScreen();
  const hasAttachment = question?.attachments?.length;

  return (
    <Stack className={cn(classes?.questionText)} direction="col">
      {question?.questionText ? (
        <RichTextViewer
          truncate
          className={cn(classes?.quizQuestion, questionCodeStyles)}
          color="text-text-primary"
          containerClassName={classes?.container}
          html={question.questionText}
          truncateLength={70}
          variant={getVariant({ isMobile })}
          {...rest}
        />
      ) : null}
      {isMobile && hasAttachment ? (
        <Box className="h-128 w-full">
          <Image
            useImg
            alt="attachment"
            className="h-full w-full rounded-8"
            src={_head(question?.attachments)?.url ?? ''}
          />
        </Box>
      ) : (
        renderAttachments({ attachments: question?.attachments, className: 'mt-12' })
      )}
    </Stack>
  );
}

export default QuestionText;
